/**
 * Validates a URL that originates from an untrusted source (localStorage,
 * API responses, etc.) before it is used in the DOM.
 *
 * Only absolute http(s) URLs are accepted. Any other value — including
 * `javascript:` / `data:` URIs (DOM XSS, CWE-79), relative or protocol
 * malformed strings (open redirect, CWE-601), non-string inputs or empty
 * values — results in an empty string being returned.
 *
 * @param url The candidate URL from an external source.
 * @returns The original URL when it is a safe http(s) URL, otherwise `''`.
 */
export function sanitizeExternalUrl(
  url: string | ArrayBuffer | null | undefined
): string {
  if (typeof url !== 'string' || url.trim() === '') {
    return '';
  }

  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return url;
    }
  } catch {
    // Malformed URL — fall through and reject.
  }

  return '';
}
